import NotOnboardedVendorsContainer from 'components/modules/Vendors/NotOnboarded/NotOnboarded';

/**
 * Primary UI component for user interaction
 */
const NotOnboardedVendors = () => {
  return <NotOnboardedVendorsContainer />;
};

export default NotOnboardedVendors;
